import { getWidthOfString } from "./functionsHtml";

function getMaxLengthFromStrArray(arr: string[]) {
  let maxLength = 0;
  for (const item of arr) {
    if (item.length > maxLength) {
      maxLength = item.length;
    }
  }
  return maxLength;
}

  // Tìm độ width lớn nhất trong mảng
  // Áp dụng để render width cho element
  function getMaxWidthFromStrArray(stringArray:string[], fontSize:string = '14px') {
    let maxWidth = 0;
    stringArray.forEach(string => {
      const stringWidth = getWidthOfString(string, fontSize);
      if (stringWidth > maxWidth) maxWidth = stringWidth;
    });
    return maxWidth;
  }

export { getMaxLengthFromStrArray,getMaxWidthFromStrArray };
